import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as ChannellistActions from './Channellist.action';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class ChannellistEffects {
  loadChannels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChannellistActions.loadChannels),
      mergeMap(() =>
        this.channelService.GetChannellist().pipe(
          map((channels) =>
            ChannellistActions.loadChannelsSuccess({ channels })
          ),
          catchError((error) =>
            of(ChannellistActions.loadChannelsFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private channelService: NSAdminbuysellRuleserviceService
  ) {}
}
